var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderindexDocumentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9682",
    "data-name": "Grupo 9682",
    transform: "translate(-230.122 -578.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9681",
    "data-name": "Grupo 9681"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2737",
    "data-name": "Ret\\xE2ngulo 2737",
    width: 13,
    height: 16,
    rx: 1,
    transform: "translate(230.622 578.678)",
    fill: "none",
    stroke: "#415364",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9680",
    "data-name": "Grupo 9680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11757",
    "data-name": "Caminho 11757",
    d: "M241.686,582.472h-9.127a.278.278,0,0,0,0,.556h9.127a.278.278,0,0,0,0-.556Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11758",
    "data-name": "Caminho 11758",
    d: "M241.686,584.044h-9.127a.277.277,0,1,0,0,.555h9.127a.277.277,0,0,0,0-.555Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11759",
    "data-name": "Caminho 11759",
    d: "M241.686,585.615h-9.127a.277.277,0,1,0,0,.555h9.127a.277.277,0,0,0,0-.555Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11760",
    "data-name": "Caminho 11760",
    d: "M241.686,587.186h-9.127a.278.278,0,0,0,0,.556h9.127a.278.278,0,0,0,0-.556Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11761",
    "data-name": "Caminho 11761",
    d: "M241.686,588.758h-9.127a.277.277,0,1,0,0,.555h9.127a.277.277,0,0,0,0-.555Z",
    fill: "#415364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11762",
    "data-name": "Caminho 11762",
    d: "M239.942,590.329H234.3c-.1,0-.172.124-.172.278s.077.278.172.278h5.639c.1,0,.172-.125.172-.278S240.037,590.329,239.942,590.329Z",
    fill: "#415364"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderindexDocumentSmall);
export default __webpack_public_path__ + "static/media/folderindex-document-small.3461a4369fddfab7c68e05632078fcd7.svg";
export { ForwardRef as ReactComponent };